"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const throttle_1 = __importDefault(require("lodash/throttle"));
const react_1 = require("react");
const libs_polyfills_1 = require("@hotelplan/libs.polyfills");
function getElementSize(element) {
    const { width: w, height: h } = element.getBoundingClientRect();
    return { w, h };
}
function useElementSize(elementRef, config = {}) {
    const { enable = true, throttle: throttleTimeout = 100, box } = config;
    const elementCurrent = elementRef.current;
    const [size, setSize] = (0, react_1.useState)(() => {
        const element = elementRef.current;
        if (element) {
            return getElementSize(element);
        }
        return { w: 0, h: 0 };
    });
    (0, react_1.useEffect)(function windowResizeEffect() {
        if (!enable) {
            return;
        }
        const throttledListener = (0, throttle_1.default)(() => {
            var _a;
            // Take fresh element reference each call
            const rect = (_a = elementRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            if (!rect)
                return;
            setSize({
                w: rect.width,
                h: rect.height,
            });
        }, throttleTimeout);
        // Wait for the next frame to calculate
        // Fix iOS opening modal lag
        requestAnimationFrame(throttledListener);
        setTimeout(throttledListener, 0);
        const resizeObserver = 'ResizeObserver' in window
            ? new window.ResizeObserver(throttledListener)
            : null;
        if (!elementCurrent)
            return;
        if (resizeObserver) {
            resizeObserver.observe(elementCurrent, { box });
        }
        else {
            window.addEventListener('resize', throttledListener, libs_polyfills_1.optionsWithPassive);
        }
        return function cleanup() {
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
            else {
                window.removeEventListener('resize', throttledListener);
            }
        };
    }, [elementRef, elementCurrent, enable, box, throttleTimeout]);
    return size;
}
exports.default = useElementSize;
//# sourceMappingURL=useElementSize.js.map